export default __webpack_public_path__ + "assets/security-08984ca.svg";